import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css',
    standalone: false
})
export class FooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  appVersion: string = environment.version;

  constructor() { }

  ngOnInit(): void {
  }

}

